/* eslint-disable filenames/no-index */
import * as React from "react";
import * as SentryReact from "@sentry/react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import "flag-icons/css/flag-icons.min.css";
/* eslint-disable no-restricted-imports */
import "@xyflow/react/dist/style.css";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Main } from "./main";
import { RootStore, setGlobalStore } from "./store";
import { initializeSentry } from "./sentry";

// Fluent UI expects this method to have been called, in order for the icons to be usable.
// Explicitly set the CDN endpoint here to match our Content Security Policy as defined in the backend.
// If changing this, take care to adjust the CSP as well.
initializeIcons("/fonts/fabric/");

(async () => {
    initializeSentry();
    const store = new RootStore();
    setGlobalStore(store);
    await store.initialize();

    // Create root element for page.
    const parentElement = document.createElement("div");
    parentElement.id = "main";
    document.body.appendChild(parentElement);

    // Decorate `<Main />` component with Sentry HOCs.
    const MainComponent = SentryReact.withProfiler(SentryReact.withErrorBoundary(Main, {}));

    const history = store.historyProvider.history;

    // Start React.
    const root = createRoot(parentElement);
    root.render(<MainComponent history={history} serviceAuth={store.serviceAuth} />);
})();
